import { render } from "./FITHeader.vue?vue&type=template&id=37a5e8d4&lang=pug"
import script from "./FITHeader.vue?vue&type=script&lang=js"
export * from "./FITHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__